import React from 'react'

import {
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
  StatusField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  trackingNumber: { id: 'trackingNumber', label: 'Tracking Number', ordering: 'tracking_number', renderer: LinkedField(ValueField) },
  client: { id: 'client.name', label: 'Client', ordering: 'account__name', renderer: ValueField },
  consignee: { id: 'address.consignee', label: 'Consignee', renderer: ValueField },
  facility: { id: 'facility.name', label: 'Facility', ordering: 'facility__name', renderer: ValueField },
  carrier: { id: 'carrier.name', label: 'Carrier', ordering: 'carrier__name', renderer: ValueField },
  status: { id: 'status', label: 'Status', renderer: StatusField },
}

export const ParcelShipmentListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title="Parcel Shipments"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
